/**
 * 新規ユーザー登録のモード(招待経由かどうか)の定義。
 *
 * Cookie に保存される一時情報で、サインアップ系の UI フローと、
 * 認証ステートマシン(registrationDraft)の双方から参照される。
 * 認証の下位レイヤである framework 側に定義を置くことで、
 * framework → user の逆依存を避ける。
 */

/** signUpMode を保存する Cookie のキー名。読み書きの双方で共有する。 */
export const SignUpModeCookieName = 'signUpMode';

const modeNames = ['withInvitation', 'withoutInvitation'] as const;
export type SignUpMode = (typeof modeNames)[number];

/** 不明な値・未設定時に採用する既定の signUpMode。 */
const FallbackSignUpMode: SignUpMode = 'withoutInvitation';

/**
 * 任意の文字列(Cookie 値など)を既知の {@link SignUpMode} に正規化する。
 * 未知の値・null の場合は {@link FallbackSignUpMode} を返す。
 */
export const getAdjustedSignUpMode = (signUpMode: string | null): SignUpMode => {
  return modeNames.find((mode) => mode === signUpMode) || FallbackSignUpMode;
};
